var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Emotions"},_vm._l((_vm.emotions),function(w,k){return _c('Emotion',{key:k,attrs:{"pos":_vm.pos[k],"id":k,"txt":w,"oeuvre_id":_vm.oeuvre_id}})}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b3f979fc","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/defis/components/Emotions.vue
// module id = null
// module chunks = 